import { NAME as name } from './constants';
import { createActionTypes } from '../core';

const NAME = name.toUpperCase();

export const GET_RESOURCE_LINKS = createActionTypes(`${NAME}/GET_RESOURCE_LINKS`);
